<template>
  <div>
    <dna-wrapper>
      <!-- 搜索栏 -->
      <dna-search-bar></dna-search-bar>
      <!-- 区块概览 -->
      <dna-info-block></dna-info-block>
      <!-- 交易详情 -->
      <dna-transfer-detail
        :hash="hash"
        :result="result"
        :status="status"
        :block="block"
        :time="time"
        :from="from"
        :to="to"
        :amount="amount"
        :token="token"
        :isLoading="isLoading"
        :method="method"
        :args="args"
      ></dna-transfer-detail>
      <!-- DNA交易详情 -->
    </dna-wrapper>
  </div>
</template>
<script>
import dnaSearchBar from "@/components/SearchBar/SearchBar.vue";
import dnaInfoBlock from "@/components/InfoBlock/InfoBlock.vue";
import dnaTransferDetail from "@/components/TransferDetail/TransferDetail.vue";
import req from "@/req/req.js";
import wsSubscribe from "@/req/wsSubscribe.js";
import util from "@/util/util.js";
export default {
  components: {
    dnaSearchBar,
    dnaInfoBlock,
    dnaTransferDetail,
  },
  data() {
    return {
      hash: "",
      result: "",
      status: "",
      block: "",
      time: "",
      from: "",
      to: "",
      amount: "",
      token: "",
      method: "",
      args: "",
      isLoading: true,
    };
  },
  async mounted() {
    let hash = this.$route.query.hash;
    let data = await req.fetchTxByHash(hash);
    if (!data) {
      data = await req.fetchTx2ByHash(hash);
    }
    if (!data) {
      this.$router
        .push({
          path: "/"
        })
        .catch((err) => {});
      return;
    }
    this.hash = this.$route.query.hash;
    this.result = data.res;
    this.status = data.status;
    this.block = data.block_num;
    this.time = util.formatDateTime(new Date(data.timestamp + "Z").getTime());
    if (data.sender) {
      let accounts = await wsSubscribe.wsFetchBtsGetAccountDetailByList([
        data.sender,
      ]);
      if (accounts && accounts.length) {
        this.from = accounts[0].name;
      }
    }
    if (data.receiver) {
      let accounts = await wsSubscribe.wsFetchBtsGetAccountDetailByList([
        data.receiver,
      ]);
      if (accounts && accounts.length) {
        this.to = accounts[0].name;
      }
    }
    this.amount = data.amount ? util.toToken(data.amount) : "";
    this.token = data.symbol;
    this.method = data.call_function;
    this.args = data.call_params;
    this.isLoading = false;
  },
};
</script>

<style lang="less" scoped>
@import url("./TransferDetail.less");
</style>